// Check if the current URL contains "/policies/privacy-policy"
if (window.location.href.indexOf('/policies/privacy-policy') !== -1) {
  // Select the element with the class "content-to-replace"
  const element = document.querySelector('.rte');

  // Check if the element was found
  if (element) {
    // Replace the content with new content
    element.innerHTML = '<comply-privacy-policy-sync apiKey="HTNXFR9-5DHMB74-G35CWCM-1BXYMNK"></comply-privacy-policy-sync>';
  } else {
    console.error('Element with class "content-to-replace" not found.');
  }
}